/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-template */
/* eslint-disable import/extensions */
/* eslint-disable object-shorthand */
/* eslint-disable prefer-destructuring */
/* eslint-disable dot-notation */
/* eslint-disable prefer-const */
/* eslint-disable arrow-body-style */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable no-loop-func */
import React, { createContext, useContext } from 'react';
import _ from 'lodash';


import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import axios from '../../../utils/axios.jsx';
import Yup from '../../../utils/yup.tsx';
import { isNumeric } from '../../../utils/utils.tsx';
import { LiftType, VrstaLifta } from '../../../utils/enums.tsx';


export const API = 'lift';
export const LANGUAGE = API;
export const name = API + 'ReduxSlice';


export const getFields = (t: any, field: string) => {
  let fields: any = [
    {
      id: 'naziv',
      name: 'naziv',
      label: t(LANGUAGE + '.table.naziv'),
      placeholder: '',
    },
    {
      id: 'grad',
      name: 'grad',
      label: t(LANGUAGE + '.table.grad'),
      placeholder: '',
    },
    {
      id: 'adresa',
      name: 'adresa',
      label: t(LANGUAGE + '.table.adresa'),
      placeholder: '',
    },
    {
      id: 'tip',
      name: 'tip',
      label: t(LANGUAGE + '.table.tip'),
      placeholder: '',
    },
    {
      id: 'vrstaLifta',
      name: 'vrstaLifta',
      label: t(LANGUAGE + '.table.vrstaLifta'),
      placeholder: '',
    },
    {
      id: 'vrstaMasine',
      name: 'vrstaMasine',
      label: t(LANGUAGE + '.table.vrstaMasine'),
      placeholder: '',
    },
    {
      id: 'nosivost',
      name: 'nosivost',
      label: t(LANGUAGE + '.table.nosivost'),
      placeholder: '',
    },
    {
      id: 'brojStanica',
      name: 'brojStanica',
      label: t(LANGUAGE + '.table.brojStanica'),
      placeholder: '',
    },
    {
      id: 'godinaProizvodnje',
      name: 'godinaProizvodnje',
      label: t(LANGUAGE + '.table.godinaProizvodnje'),
      placeholder: '',
    },
    {
      id: 'proizvodjac',
      name: 'proizvodjac',
      label: t(LANGUAGE + '.table.proizvodjac'),
      placeholder: '',
    },
    {
      id: 'sifraProizvodjaca',
      name: 'sifraProizvodjaca',
      label: t(LANGUAGE + '.table.sifraProizvodjaca'),
      placeholder: '',
    },
    {
      id: 'saKucicom',
      name: 'saKucicom',
      label: t(LANGUAGE + '.table.saKucicom'),
      placeholder: '',
    },
    {
      id: 'isActive',
      name: 'isActive',
      label: t(LANGUAGE + '.table.isActive'),
      placeholder: '',
    },
  ];

  return fields.find((x: any) => x.id === field);
}

export const formSchema = (t: any) => {
  return Yup.object().shape({
    naziv: Yup.string().required().label(getFields(t, 'naziv')?.label),
    grad: Yup.string().required().label(getFields(t, 'grad')?.label),
    adresa: Yup.string().required().label(getFields(t, 'adresa')?.label),
    tip: Yup.number().required().label(getFields(t, 'tip')?.label),
    vrstaLifta: Yup.number().required().label(getFields(t, 'vrstaLifta')?.label),
    vrstaMasine: Yup.string().required().label(getFields(t, 'vrstaMasine')?.label),
    nosivost: Yup.number().required().label(getFields(t, 'nosivost')?.label),
    brojStanica: Yup.number().required().label(getFields(t, 'brojStanica')?.label),
    saKucicom: Yup.boolean(),
    godinaProizvodnje: Yup.number().required().label(getFields(t, 'godinaProizvodnje')?.label),
    sifraProizvodjaca: Yup.string().required().label(getFields(t, 'sifraProizvodjaca')?.label),
    isActive: Yup.boolean(),
    proizvodjac_id: Yup.number().required().label(getFields(t, 'proizvodjac')?.label),
  })
}


let formikContext: any = null;
export const FormikContext = createContext<any>(null);
export const useFormikContext = () => {
    formikContext = useContext(FormikContext);
    if (!formikContext) {
      throw new Error('useFormikContext must be used within a FormikProvider');
    }
    return formikContext;
};


export const prepareForm = (values: any = null, defValues: any = null) => {
  let form = _.cloneDeep(values);
  let data = _.cloneDeep(defValues);

  if(data && form){
    let proizvodjac_id = (form && isNumeric(form.proizvodjac_id)) ? form.proizvodjac_id : null;

    data['naziv'] = form?.naziv || '';
    data['grad'] = form?.grad || '';
    data['adresa'] = form?.adresa || '';
    data['tip'] = form?.tip || LiftType.Hidraulicni;
    data['vrstaLifta'] = form?.vrstaLifta || VrstaLifta.Putnicki;
    data['vrstaMasine'] = form?.vrstaMasine || '';
    data['nosivost'] = form?.nosivost || null;
    data['brojStanica'] = form?.brojStanica || null;
    data['saKucicom'] = form?.saKucicom || false;
    data['godinaProizvodnje'] = form?.godinaProizvodnje || null;
    data['sifraProizvodjaca'] = form?.sifraProizvodjaca || '';
    data['proizvodjac_id'] = proizvodjac_id;
    data['proizvodjac'] = form?.proizvodjac || null;
    data['isActive'] = form?.isActive || false;
  }

  return data;
};
export const prepareData = (values: any = null, id: number|null) => {
  let data: any = {};

  if(values){
    let proizvodjac_id = (values && isNumeric(values.proizvodjac_id)) ? values.proizvodjac_id : null;

    data['naziv'] = values?.naziv || '';
    data['grad'] = values?.grad || '';
    data['adresa'] = values?.adresa || '';
    data['tip'] = values?.tip || LiftType.Hidraulicni;
    data['vrstaLifta'] = values?.vrstaLifta || VrstaLifta.Putnicki;
    data['vrstaMasine'] = values?.vrstaMasine || '';
    data['nosivost'] = values?.nosivost || null;
    data['brojStanica'] = values?.brojStanica || null;
    data['saKucicom'] = values?.saKucicom || false;
    data['godinaProizvodnje'] = values?.godinaProizvodnje || null;
    data['sifraProizvodjaca'] = values?.sifraProizvodjaca || '';
    data['proizvodjac_id'] = proizvodjac_id;
    data['proizvodjac'] = values?.proizvodjac || null;
    data['isActive'] = values?.isActive || false;

    if (isNumeric(id)) {
      data['id'] = id;
    }
  }

  return data;
};


export interface initialValuesStruct {
  naziv: string,
  grad: string,
  adresa: string,
  tip: number|null,
  vrstaLifta: number|null,
  vrstaMasine: string,
  nosivost: number|null,
  brojStanica: number|null,
  isActive: boolean,
  saKucicom: boolean,
  godinaProizvodnje: number|null,
  sifraProizvodjaca: string,
  proizvodjac_id: any,
};
export const initialValues: initialValuesStruct = {
  naziv: '',
  grad: '',
  adresa: '',
  tip: LiftType.Hidraulicni,
  vrstaLifta: VrstaLifta.Putnicki,
  vrstaMasine: '',
  nosivost: null,
  brojStanica: null,
  saKucicom: false,
  godinaProizvodnje: null,
  sifraProizvodjaca: '',
  isActive: true,
  proizvodjac_id: null,
};


interface InitState {
  isLoading: boolean,
  show: boolean,
  id: number|null,
  payload: any,
  details: any,
  items: Array<any>,
}

function NewReducer() {
  const initialState: InitState = {
    isLoading: false,
    show: false,
    id: null,
    payload: null,
    details: null,
    items: [],
  };


  const reducers = {
    resetSlice: () => {
      return initialState;
    },
    setLoading: (state: InitState, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setShow: (state: InitState, action: PayloadAction<{ show: boolean, id: number|null, payload: any }>) => {
      state.id = action.payload.id;
      state.payload = action.payload.payload;
      state.show = action.payload.show;
    },
    setValues: (state: InitState, action: PayloadAction<any>) => {
      state.details = action.payload;
    },

    startRead: (state: InitState) => {
      state.isLoading = true;
      state.items = [];
    },
    finishRead: (state: InitState, action: PayloadAction<any>) => {
      let data = (action.payload && action.payload.data && action.payload.data.length > 0) ? action.payload.data : [];
      state.items = data;
      state.isLoading = false;
    },

    startDetails: (state: InitState) => {
      state.isLoading = true;
    },
    finishDetails: (state: InitState, action: PayloadAction<any>) => {
      state.isLoading = false;
      state.details = action.payload;
    },

    startCreate: (state: InitState) => {
      state.isLoading = true;
    },
    finishCreate: (state: InitState, action: PayloadAction<any>) => {
      state.isLoading = false;
    },

    startUpdate: (state: InitState) => {
      state.isLoading = true;
    },
    finishUpdate: (state: InitState, action: PayloadAction<any>) => {
      state.isLoading = false;
    },

    startDelete: (state: InitState) => {
      state.isLoading = true;
    },
    finishDelete: (state: InitState, action: PayloadAction<any>) => {
      state.isLoading = false;
    },
  };


  const apis = {
    callReadApi: (params: any, callback: (state: boolean, data: any, message: string) => void) => async (dispatch: any) => {
      dispatch(actions.startRead());

      await axios.get(API, { params: params }).then((result: any) => {
        const { data, message } = result.data;

        callback(true, data, message);
        dispatch(actions.finishRead(data));
      }).catch((error: any) => {
        const { message } = error;

        callback(false, null, message);
        dispatch(actions.finishRead(null));
      });
    },

    callDetailsApi: (id: number|null, callback: (state: boolean, data: any, message: string) => void) => async (dispatch: any) => {
      dispatch(actions.startDetails());

      await axios.get(API + '/' + id).then((result: any) => {
        const { data, message } = result.data;

        callback(true, data, '');
        dispatch(actions.finishDetails(data));
      }).catch((error: any) => {
        const { message } = error;

        callback(false, null, message);
        dispatch(actions.finishDetails(null));
      });
    },

    callCreateApi: (params: any, callback: (state: boolean, data: any, message: string) => void) => async (dispatch: any) => {
      dispatch(actions.startCreate());

      await axios.post(API, params).then((result: any) => {
        const { data, message } = result.data;

        callback(true, data, message);
        dispatch(actions.finishCreate(data));
      }).catch((error: any) => {
        const { message } = error;

        callback(false, null, message);
        dispatch(actions.finishCreate(null));
      });
    },

    callUpdateApi: (params: any, callback: (state: boolean, data: any, message: string) => void) => async (dispatch: any) => {
      dispatch(actions.startUpdate());

      await axios.put(API + '/' + params?.id, params).then((result: any) => {
        const { data, message } = result.data;

        callback(true, data, message);
        dispatch(actions.finishUpdate(data));
      }).catch((error: any) => {
        const { message } = error;

        callback(false, null, message);
        dispatch(actions.finishUpdate(null));
      });
    },

    callDeleteApi: (params: any, callback: (state: boolean, data: any, message: string) => void) => async (dispatch: any) => {
      dispatch(actions.startDelete());

      await axios.delete(API + '/' + params?.id, { data: params }).then((result: any) => {
        const { data, message } = result.data;

        callback(true, data, message);
        dispatch(actions.finishDelete(data));
      }).catch((error: any) => {
        const { message } = error;

        callback(false, null, message);
        dispatch(actions.finishDelete(null));
      });
    },
  };


  const { reducer, actions } = createSlice({
    name,
    initialState,
    reducers,
  });


  return {
    reducer,
    ...actions,
    ...apis,
  };
}


export default NewReducer();
